import Icon from '../atomic/Icon'

const Header = props => {
  return (
    <header id="header">
      <div className="header__content">
        <div id="logo" className="header__logo">
          <a href="/">
            <Icon id="logo-giuntiscuola-color" classes="header__logo-mono" />
            <Icon id="logo-giuntiscuola-color--colored" classes="header__logo-colored" />
          </a>
        </div>
        <div className="header__right">
          <div className="header__bottom"></div>
        </div>
      </div>
    </header>
  )
}

export default Header
